import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\">\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\n    <title>向下箭头</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-down_向下箭头\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" opacity=\"0.600000024\">\n        <path d=\"M3.5,3.5 L3.5,10.25 C3.5,10.6642136 3.16421356,11 2.75,11 C2.33578644,11 2,10.6642136 2,10.25 L2,2.75 C2,2.33578644 2.33578644,2 2.75,2 L10.25,2 C10.6642136,2 11,2.33578644 11,2.75 C11,3.16421356 10.6642136,3.5 10.25,3.5 L3.5,3.5 Z\" fill=\"#FFFFFF\" transform=\"translate(6.500000, 6.500000) rotate(-135.000000) translate(-6.500000, -6.500000) \" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 107